module.exports = __webpack_public_path__ + "static/img/stay-option-icon-conditioner.75064942.svg";